import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-trust-security-section',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './trust-security-section.component.html',
  styleUrl: './trust-security-section.component.scss'
})
export class TrustSecuritySectionComponent {
  benefitItems = [
    {
      icon: 'badge',
      title: 'Memberships & renewals',
      description: 'Track member types, terms, renewals, and status in one record—without duplicate rosters across tools.'
    },
    {
      icon: 'event',
      title: 'Events & registration',
      description: 'Manage schedules, pricing, capacity, and attendee lists tied directly to members—not in a separate events system.'
    },
    {
      icon: 'payments',
      title: 'Payments & dues',
      description: 'Keep dues, invoices, and event charges attached to the right member record—without manual reconciliation.'
    },
    {
      icon: 'assignment_turned_in',
      title: 'Applications & approvals',
      description: 'Run intake, review, and approval workflows in one place—instead of scattered email threads.'
    },
    {
      icon: 'table_chart',
      title: 'Reporting & directories',
      description: 'Generate searchable directories, exports, and board-ready views from live data—not rebuilt spreadsheets.'
    }
  ];
}
